/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {OrganizationSetup} from './components/OrganizationSetup'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'
import {SETUP_API} from '../../config/api.config'

const AuthLayout = ({orgInfo, appVersion}: {orgInfo?: {orgName: string; orgId: string; address?: string} | null, appVersion?: string}) => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12 theme-dark-show'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/bedrock/bedrock-logo-dark.png')} className='h-95px' />
        </a>

        <a href='#' className='mb-12 theme-light-show'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/bedrock/bedrock-logo-light.png')} className='h-95px' />
        </a>

        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto border border-primary border-2'>
          <Outlet />
        </div>
        {/* end::Wrapper */}

        {/* begin::Organization Footer */}
        {orgInfo && (
          <div className='w-lg-500px mx-auto mt-4 text-center'>
            <span className='text-gray-500 fs-7'>
              Registered to <span className='fw-bold text-primary'>{orgInfo.orgName}</span>
            </span>
            {orgInfo.address && (
              <div className='text-gray-400 fs-9 mt-1'>{orgInfo.address}</div>
            )}
          </div>
        )}
        {/* end::Organization Footer */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        {appVersion && (
          <span className='text-gray-400 fs-9'>v{appVersion}</span>
        )}
      </div>
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => {
  const [loading, setLoading] = useState(true)
  const [setupNeeded, setSetupNeeded] = useState(false)
  const [orgInfo, setOrgInfo] = useState<{orgName: string; orgId: string; address?: string} | null>(null)
  const [appVersion, setAppVersion] = useState<string>('')

  useEffect(() => {
    const checkSetupStatus = async () => {
      try {
        console.log("Checking setup status...")
        console.log("SETUP_API.CHECK_STATUS:", SETUP_API.CHECK_STATUS)
        const {data} = await axios.get(SETUP_API.CHECK_STATUS)
        console.log("Setup status response:", data)
        setSetupNeeded(data.setupNeeded)
        if (data.organization) {
          setOrgInfo(data.organization)
        }
        if (data.appVersion) {
          setAppVersion(data.appVersion)
        }
      } catch (error) {
        console.error('Error checking setup status:', error)
      } finally {
        setLoading(false)
      }
    }

    checkSetupStatus()
  }, [])

  // Show loading state while checking setup status
  if (loading) {
    return (
      <div className='d-flex flex-column flex-root'>
        <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
          <div className='d-flex flex-column flex-lg-row-auto w-xl-600px'>
            <div className='d-flex flex-center flex-column flex-column-fluid'>
              <div className='w-lg-600px p-10'>
                <div className='text-center'>
                  <div className='spinner-border text-primary' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                  <div className='mt-3'>Loading...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      <Route element={<AuthLayout orgInfo={orgInfo} appVersion={appVersion} />}>
        {setupNeeded ? (
          <>
            <Route path='*' element={<OrganizationSetup />} />
            <Route index element={<OrganizationSetup />} />
          </>
        ) : (
          <>
            <Route path='login' element={<Login />} />
            <Route path='registration' element={<Registration />} />
            <Route path='forgot-password' element={<ForgotPassword />} />
            <Route index element={<Navigate to='/auth/login' />} />
          </>
        )}
      </Route>
    </Routes>
  )
}

export {AuthPage}
